export const FORM_COMPONENTS = {
  INPUT: "Input",
  CHECKBOX: "Checkbox",
  BUTTON_OPTIONS: "ButtonOptions",
  BUTTON_WITH_IMAGE_OPTIONS: "ButtonWithImageOptions",
  ICON_BUTTON_OPTIONS: "IconButtonOptions",
  DROP_DOWN: "DropDown",
  DROP_DOWN_WITH_DETAILS: "DropDownWithDetails",
  GOALIE_GEAR_COLOR_OPTIONS: "GoalieGearColorOptions",
  GROUPED_BUTTON_OPTIONS: "GroupedButtonOptions",
  GROUPED_ICON_BUTTON_OPTIONS: "GroupedIconButtonOptions",
  SET_OF_GROUPED_ICON_BUTTON_OPTIONS: "SetOfGroupedIconButtonOptions",
  SKATE_CUSTOMISE_BLADE: "SkateCustomiseBlade",
  SKATE_HOLDER_LENGTH: "SkateHolderLength",
};

export const PLAYER_NAME_FIELD_NAMES = ["playerName", "personalizedName"];

export const ALLOWED_CHARACTERS_WITH_ACCENTS = "åäöæøüÅÄÖÆØÜ";
